import request from "./request";

// 用户登录
export function login(data) {
  return request({
    url: "/api/auth/login",
    method: "post",
    data,
  });
}

// 获取当前用户信息
export function getUserInfo() {
  return request({
    url: "/api/auth/profile",
    method: "get",
  });
}

// 更新个人资料（仅支持 nickname / avatar）
export function updateProfile(data) {
  return request({
    url: "/api/auth/profile",
    method: "put",
    data,
  });
}

// 修改密码
export function changePassword(data) {
  return request({
    url: "/api/auth/change-password",
    method: "put",
    data,
  });
}

// 刷新令牌
export function refreshToken() {
  return request({
    url: "/api/auth/refresh-token",
    method: "post",
  });
}

// 退出登录
export function logout() {
  return request({
    url: "/api/auth/logout",
    method: "post",
  });
}

// ── 账号管理（super_admin 专用） ────────────────────────────────

export function getAdminUserList(params) {
  return request({ url: "/api/roles/users", method: "get", params });
}

export function createAdminUser(data) {
  return request({ url: "/api/roles/users", method: "post", data });
}

export function updateAdminUserRole(id, role) {
  return request({ url: `/api/roles/users/${id}/role`, method: "patch", data: { role } });
}

export function updateAdminUserStatus(id, status) {
  return request({ url: `/api/roles/users/${id}/status`, method: "patch", data: { status } });
}

export function updateAdminUserStaffId(id, staff_id) {
  return request({ url: `/api/roles/users/${id}/staff-id`, method: "patch", data: { staff_id } });
}

export function resetAdminUserPassword(id, new_password) {
  return request({ url: `/api/roles/users/${id}/password`, method: "patch", data: { new_password } });
}

export function deleteAdminUser(id) {
  return request({ url: `/api/roles/users/${id}`, method: "delete" });
}

export function updateAdminUserExtra(id, data) {
  return request({ url: `/api/roles/users/${id}/extra`, method: "patch", data });
}

export function unlockAdminUser(id) {
  return request({ url: `/api/roles/users/${id}/unlock`, method: "patch" });
}
